import { makeStyles } from 'transfix-ui/core'

export const useSidebarCardRowStyles = makeStyles(theme => ({
  row: {
    paddingTop: theme.spacing(2),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2,
  },
  item: {
    flexBasis: 0,
    marginRight: '10px',
  },
  buttonWrapper: {
    flex: '0 0 auto',
    textAlign: 'right',
  },
}))
